import { render, staticRenderFns } from "./newspaper.vue?vue&type=template&id=59495748&scoped=true&"
import script from "./newspaper.vue?vue&type=script&lang=js&"
export * from "./newspaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59495748",
  null
  
)

export default component.exports